import Toolbar, { ToolbarProps } from "@mui/material/Toolbar";

export type { ToolbarProps };

export default Toolbar;
